export default {
    indexVacancyControl:    { method: 'get', url: 'ambience_links/vacancy_control' },
    indexOccupancyDashboard:{ method: 'get', url: 'occupancy_dashboard' },
    showDashboardSettings:  { method: 'get', url: 'occupancy_dashboard/settings' },
    showAmbienceDetail:     { method: 'get', url: 'occupancy_dashboard/ambience/{id}' },
    applySubstitutionsBulk: { method: 'post', url: 'class_schedules/substitutions/bulk' },
    applySubstitutionSingle:{ method: 'put',  url: 'class_schedules/{id}/ambience/apply' },
    revertSubstitution:     { method: 'post', url: 'class_schedules/substitutions/{logId}/revert' },
    indexSubstitutionLogs:  { method: 'get',  url: 'ambience_substitution_logs' },
}